import RegistrationPage from "../RegistrationPage.vue";
import RegistrationTypeEnum from "@/enums/RegistrationTypeEnum";

/** Token analysé par le serveur */
export type AnalyseTokenResponse = {
    Expired: boolean
    Type: RegistrationTypeEnum
    Email: string 
    Login: string
    HasPasswordPolicy: boolean
    CharLength: number
    CharDigit: number
    CharSpecial: number
    CharUpperCase: number
    CharSpecialList: string
}

/** Déclaration de la machine à états dédiée aux enregistrements/activations/resets */
export interface IRegistrationState{
    /** Lance l'état suivant */
    Next(): Promise<void>;
}

/** Base commune des états du pattern "state" dédiée aux enregistrements/activations/resets */
export abstract class RegistrationState implements IRegistrationState{
    protected context: RegistrationPage;
    protected token: string;
    protected analyseToken: AnalyseTokenResponse;

    /** Constructeur par défaut pour conservé la transmition d'information entre les états */
    constructor(previousState: RegistrationState){
        if(previousState != null){
            this.context = previousState.context;
            this.token = previousState.token;
            this.analyseToken = previousState.analyseToken;
        }
    }

    public abstract Next(): Promise<void> ;
}